import React, { PropsWithChildren } from 'react';
import { TabsContext, TabsOptions, TTab, useTabs } from 'components/commons/_/tabs/TabsContext';

export const Tabs = <T extends TTab>({ children, ...options }: PropsWithChildren<TabsOptions<T>>) => {
	const value = useTabs<T>(options);

	return <TabsContext.Provider value={value}>{children}</TabsContext.Provider>;
};
